// import moment from 'moment';
import {
  call,
  put,
  // select,
} from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsToken from '@netsapiens/netsapiens-js/dist/token';

import {
  setLoading,
} from '../../../state/chat/chatSlice';

export default function* checkSmsQueueSession({ payload }) {
  const debug = false;

  if (debug) console.debug('in checkSmsQueueSession payload: ', payload);

  const { session } = payload;
  const decodedToken = nsToken.getDecoded();

  const messageSessionToCheck = yield call(nsApi.v2, {
    object: 'messagesessions',
    action: 'get',
  }, `domains/${decodedToken.domain}/users/${decodedToken.user}/messagesessions/${session.session_id}`);

  yield put(setLoading(false));

  if (debug) console.debug('at the end of checkSmsQueueSession messageSessionToCheck: ', messageSessionToCheck);

  return messageSessionToCheck[0] || null;
}
